import {
  SuccessionFilterTypeDto,
  SuccessorChangeLogHistoryTypeDto,
  SuccessorColourDto,
} from '@/api/generated';
import { SuccessionTranslation } from '@/assets/locales/views/succession/succession.translation.en.ts';

export const successionTranslation: SuccessionTranslation = {
  addSuccessor: 'Dodaj nowego sukcesora',
  card: {
    addTalentPanel: 'Zapisz panel talentowy',
    afterTalentPanel: 'Po panelu talentowym',
    age: 'Wiek',
    averageRisk: 'średnie',
    careerPaths: 'ŚCIEŻKI KARIERY',
    comment: 'Komentarz',
    countryOfWork: 'Kraj pracy',
    delete: 'Usuń sukcesora',
    deleteNode: 'Usuń element',
    domesticMobility: 'Mobilność krajowa',
    editCareerPaths: 'Edytuj ścieżki kariery',
    editColor: 'Edytuj kolor',
    editComment: 'Edytuj komentarz',
    exCommPipeline: 'Ścieżka ExComm',
    expatPipeline: 'Ścieżka ekspata',
    functionalGrade: 'FG',
    globalAssignment: 'Oddelegowanie zagraniczne',
    goToProfile: 'Przejdź do profilu',
    highRisk: 'wysokie',
    history: 'Historia zmian',
    internationalMobility: 'Mobilność międzynar.',
    jobSeniority: 'Job',
    longAbsence: 'Długa absencja',
    lowRisk: 'niskie',
    managementTrainee: 'Program Management Trainee',
    mobility: 'Mobilność',
    months: 'm.',
    no: 'Nie',
    noCareerPaths: 'Nie dodano jeszcze ścieżki kariery.',
    noComment: 'Nie dodano jeszcze komentarza.',
    personalGrade: 'PG',
    pmc: 'PMC',
    positionLevel: {
      managerial: 'Managerski',
      operational: 'Operacyjny',
      strategic: 'Strategiczny',
    },
    positionSeniority: 'Staż na obecnym stanowisku',
    region: 'Region',
    reportsTo: 'Raportuje do',
    riskOfLeaving: 'Ryzyko odejścia',
    sop: 'SOP',
    talentPanels: 'Panele talentowe',
    viewFullComment: 'Pokaż cały komentarz',
    workSeniority: 'JM',
    years: 'lat',
    yes: 'Tak',
  },
  changelog: {
    clearFilter: 'Wyczyść filtr',
    exportButton: 'Eksportuj Historię',
    exporting: 'Eksportowanie...',
    exportTooltip: 'Eksportuj historię zmian sukcesji do pliku Excel',
    filteredBy: 'Historia pracownika',
    pageInfo: 'Strona {{page}} z {{total}}',
  },
  excelReport: {
    addSuccessorButton: 'Dodaj sukcesora',
    addSuccessorTooltip: 'Dodaj nowego sukcesora na wybrane stanowisko',
    exportButton: 'Pobierz raport',
    exportTooltip: 'Pobierz raport sukcesji w formacie Excel',
  },
  form: {
    careerPathFilters: 'Szukaj w ścieżce kariery',
    clearFilters: 'Wyczyść',
    clearing: 'Czyszczenie...',
    collapseSearchBar: 'Zwiń wyszukiwarkę',
    emptyState: {
      buttonText: 'Otwórz filtry wyszukiwania',
      description:
        'Użyj zaawansowanych filtrów aby znaleźć sukcesorów na kluczowe stanowiska w organizacji lub sprawdź pracowników aktualnie gotowych do awansu.',
      hint: 'Możesz również przeszukiwać według stanowiska, regionu, gotowości i innych kryteriów',
      title: 'Zacznij planowanie sukcesji',
    },
    expandSearchBar: 'Rozwiń wyszukiwarkę',
    feSideValues: {
      ageBucket: {
        BETWEEN_35_40: '35-40',
        BETWEEN_40_55: '41-55',
        GT_55: 'Powyżej 55',
        LT_35: 'Poniżej 35',
      },
      mobility: {
        INTERNATIONAL_NO: 'Międzynarodowa: nie',
        INTERNATIONAL_YES: 'Międzynarodowa: tak',
        NATIONAL_NO: 'Krajowa: nie',
        NATIONAL_YES: 'Krajowa: tak',
      },
      noRating: 'Brak oceny',
    },
    fields: {
      [SuccessionFilterTypeDto.AgeBucket]: 'Wiek',
      [SuccessionFilterTypeDto.Department]: 'Departament',
      [SuccessionFilterTypeDto.EmployeeSuccessionReadiness]: 'Gotowość',
      [SuccessionFilterTypeDto.FunctionalArea]: 'Obszar funkcyjny',
      [SuccessionFilterTypeDto.FunctionalSupervisor]: 'Przełożony funkcjonalny',
      [SuccessionFilterTypeDto.Grade]: 'Grade',
      [SuccessionFilterTypeDto.HierarchicalSupervisor]: 'Hierarchiczny przełożony',
      [SuccessionFilterTypeDto.JobLevel]: 'Poziom stanowiska',
      [SuccessionFilterTypeDto.Matrix]: 'Pole na matrycy',
      [SuccessionFilterTypeDto.Mobility]: 'Mobilność',
      [SuccessionFilterTypeDto.Mt]: 'Management Trainee – rok',
      [SuccessionFilterTypeDto.PmcRating]: 'Ocena PMC',
      [SuccessionFilterTypeDto.Position]: 'Stanowisko',
      [SuccessionFilterTypeDto.Region]: 'Region',
      [SuccessionFilterTypeDto.SopRating]: 'Ocena SOP',
      [SuccessionFilterTypeDto.SuccessionDepartment]: 'Departament',
      [SuccessionFilterTypeDto.SuccessionPosition]: 'Stanowisko',
      [SuccessionFilterTypeDto.Zone]: 'Zona',
    },
    filters: 'Filtry',
    filtersActive: 'Filtry aktywne',
    highRiskOfLeaving: 'Wyświetl pracowników z wysokim ryzykiem odejścia',
    noFilters: 'Brak filtrów',
    noResults: 'Brak wyników',
    resetButton: 'Resetuj',
    results: 'wyników',
    searchBarTitle: 'Filtry wyszukiwania',
    searchFor: {
      current: 'Pracownicy na stanowisku',
      successor: 'Sukcesorzy na stanowisko',
    },
    searchForDisplay: {
      current: 'Pracownicy na stanowisku',
      successor: 'Sukcesorzy na stanowisko',
    },
    searching: 'Wyszukiwanie...',
    selectAll: 'Zaznacz wszystko',
    textSearchFields: {
      externalEmployeeId: 'Nr SAP',
      firstName: 'Imię',
      lastName: 'Nazwisko',
    },
    toggleTooltip: {
      current: 'Kliknij aby przełączyć na: Przeglądasz pracowników na stanowiskach',
      successor: 'Kliknij aby przełączyć na: Przeglądasz sukcesorów na stanowiska',
    },
    uploadButton: 'Szukaj',
    viewChangeLog: 'Zobacz historię zmian',
  },
  functionalAreasDashboard: {
    contextMenu: {
      showEmployees: 'Pokaż pracowników',
      showSuccessors: 'Pokaż sukcesorów',
    },
    filters: {
      excellent: 'Doskonały',
      good: 'Dobry',
      needsAttention: 'Wymaga uwagi',
    },
    functionalAreaPlaceholder: 'Obszar funkcyjny',
    scrollToFunctionalAreas: 'Obszary Funkcyjne',
    scrollToPositions: 'Stanowiska',
    sections: {
      functionalAreas: 'Obszary Funkcyjne',
      positions: 'Stanowiska',
    },
    show: 'Pokaż:',
    title: 'Dashboard',
  },
  headerDashboard: {
    greenMatrix: 'Potencjał liderski',
    highRiskOfLeaving: 'Wysokie ryzyko odejścia',
    olderOrEqualTo55YearsOld: 'Wiek 55+',
    ready1To2YearsForPromotion: 'Gotowi 1-2 lata',
    ready3To5YearsForPromotion: 'Gotowi 3-5 lat',
    readyForPromotion: 'Gotowi do awansu',
    readyNowForPromotion: 'Gotowi teraz',
    readyUpTo1YearForPromotion: 'Gotowi do 1 roku',
    sectionTitle: 'Statystyki sukcesji',
  },
  inPosition: 'na stanowisku',
  legend: {
    colors: {
      green: 'Pracownik gotowy objąć bardziej odpowiedzialną rolę',
      grey: 'Pracownik',
      red: 'Alert',
      yellow: 'Pracownik do obserwacji',
    },
    exclamation: 'Wysokie ryzyko odejścia',
    icons: {
      countryOfWork: 'Kraj pracy',
      domesticMobility: 'ExComm Pipeline',
      internationalMobility: 'Expat Pipeline',
      managementTrainee: 'Trainee',
      portugueseEmail: 'Przypisanie globalne',
    },
    title: 'Legenda',
  },
  loadMore: 'Pokaż więcej',
  modals: {
    addSuccessor: {
      cancelButton: 'Anuluj',
      fields: {
        comment: {
          label: 'Komentarz',
          placeholder: 'Wprowadź komentarz',
        },
        employee: {
          label: 'Wybierz pracownika',
          placeholder: 'Wprowadź SAP lub imię i nazwisko pracownika',
        },
        main: 'Ustaw jako główną ścieżkę kariery ',
        position: {
          label: 'Stanowisko',
          placeholder: 'Wybierz stanowisko',
        },
        readiness: {
          label: 'Gotowość',
          placeholder: 'Wybierz gotowość',
        },
      },
      submitButton: 'Dodaj sukcesora',
      title: 'Dodaj sukcesora',
    },
    comment: {
      cancelButton: 'Anuluj',
      characterCount: '{{current}}/{{max}} znaków',
      label: 'Komentarz',
      placeholder: 'Dodaj komentarz',
      submitButton: 'Zapisz',
      title: 'Aktualizuj komentarz',
    },
    deleteSuccessor: {
      cancelButton: 'Anuluj',
      fields: {
        comment: {
          label: 'Komentarz',
          placeholder: 'Podaj powód usunięcia',
        },
      },
      submitButton: 'Usuń sukcesora',
      title: 'Usuń sukcesora',
    },
    editCareer: {
      title: 'Edycja ścieżek kariery',
    },
    editSuccession: {
      editCareer: {
        addPath: {
          fields: {
            comment: {
              label: 'Komentarz',
              placeholder: 'Podaj powód dodania ścieżki kariery',
            },
            main: 'Główna',
            position: 'Stanowisko',
            readiness: 'Gotowość',
          },
          submitButton: 'Dodaj ścieżkę',
          title: 'Dodaj ścieżkę kariery',
        },
        addPathButton: 'Dodaj ścieżkę kariery',
        deletePath: {
          comment: {
            label: 'Komentarz',
            placeholder: 'Podaj powód usunięcia ścieżki kariery',
          },
          submitButton: 'Usuń ścieżkę',
          title: 'Usuń ścieżkę kariery',
        },
        editPath: {
          comment: 'Powód zmiany ścieżki kariery',
          submitButton: 'Zapisz zmiany',
          title: 'Edycja ścieżki kariery',
        },
        mainBadge: 'Główna',
        name: {
          false: 'Edycja ścieżki',
          true: 'Edycja ścieżki kariery',
        },
        noCareerPaths: 'Brak ścieżek kariery',
        noReadiness: 'Brak gotowości',
        pathsSectionLabel: 'Ścieżki kariery',
        positionLabel: 'Stanowisko',
      },
      editColor: {
        color: {
          [SuccessorColourDto.Green]: 'Zielony',
          [SuccessorColourDto.Grey]: 'Szary',
          [SuccessorColourDto.Red]: 'Czerwony',
          [SuccessorColourDto.Yellow]: 'Żółty',
        },
        colorLabel: 'Kolor Statusu',
        comment: {
          label: 'Komentarz',
          placeholder: 'Powód zmiany statusu',
        },
        name: 'Edycja koloru',
        noPermission: 'Nie masz uprawnień do zmiany koloru statusu.',
        submitButton: 'Aktualizuj kolor',
      },
      editExclamationMark: {
        comment: {
          label: 'Komentarz',
          placeholder: 'Powód zmiany statusu',
        },
        exclamationMark: 'Pokaż wykrzyknik',
        name: 'Edycja statusu wykrzyknika',
        submitButton: 'Aktualizuj status',
      },
      title: 'Edycja sukcesora',
    },
    history: {
      by: 'Przez',
      noHistory: 'Brak historii zmian',
      sap: 'SAP:',
      title: 'Historia zmian',
      type: {
        [SuccessorChangeLogHistoryTypeDto.CareerPathAdd]: 'Dodano ścieżkę kariery',
        [SuccessorChangeLogHistoryTypeDto.CareerPathDelete]: 'Usunięto ścieżkę kariery',
        [SuccessorChangeLogHistoryTypeDto.CareerPathUpdate]: 'Zaktualizowano ścieżkę kariery',
        [SuccessorChangeLogHistoryTypeDto.ColourUpdate]: 'Zaktualizowano kolor',
        [SuccessorChangeLogHistoryTypeDto.EmployeeCommentUpdate]:
          'Zaktualizowano komentarz pracownika',
        [SuccessorChangeLogHistoryTypeDto.ExclamationMarkUpdate]: 'Zaktualizowano wykrzyknik',
        [SuccessorChangeLogHistoryTypeDto.ExcommUpdate]: 'Zaktualizowano status ExComm Pipeline',
        [SuccessorChangeLogHistoryTypeDto.ExpatUpdate]: 'Zaktualizowano status Expat Pipeline',
      },
    },
  },
  noHistory: {
    description: 'W historii sukcesji nie ma jeszcze żadnych zarejestrowanych zmian.',
    title: 'Brak historii',
  },
  organizationChart: {
    buttons: {
      collapseAll: 'Zwiń wszystkie',
      expandAll: 'Rozwiń wszystkie',
      search: 'Szukaj',
    },
    deleteNode: {
      buttons: {
        cancel: 'Anuluj',
        confirm: 'Usuń element',
      },
      hierarchyType: {
        organizational: 'hierarchii organizacyjnej',
        personal: 'hierarchii personalnej',
      },
      prompt: {
        employeeAction: 'Wybierz akcję dla pracownika:',
        leaf: 'Czy na pewno chcesz usunąć ten element z {{hierarchy}}?',
        strategy: 'Wybierz strategię usuwania elementu z {{hierarchy}}:',
      },
      strategies: {
        convertToVacancy: {
          description:
            'Element pracownika zostanie przekształcony w wakat. Struktura hierarchii pozostanie niezmieniona.',
          label: 'Konwertuj pracownika na wakat',
        },
        deleteEmployee: {
          description:
            'Element pracownika zostanie usunięty z hierarchii. Ta operacja jest nieodwracalna.',
          label: 'Usuń element',
        },
        deleteWithChildren: {
          description:
            'Element oraz wszystkie jego podelementy zostaną usunięte z hierarchii. Ta operacja jest nieodwracalna.',
          label: 'Usuń element wraz ze wszystkimi podelementami',
        },
        promoteChildren: {
          description:
            'Element zostanie usunięty, a jego dzieci zostaną przypisane do elementu nadrzędnego. Poziomy hierarchii zostaną przeliczone.',
          label: 'Usuń element i promuj dzieci do rodzica',
        },
      },
      title: 'Usuń element',
      warning: 'Tej operacji nie można cofnąć.',
    },
    displaySettings: {
      applyToLevel: 'Rodzeństwo',
      applyToNode: 'Tylko ten pracownik',
      fields: {
        age: 'Wiek',
        flags: 'Flagi (kraj, expat)',
        functionalGrade: 'Functional Grade',
        matrix: 'Matryca',
        monthsInCompany: 'Staż pracy JM',
        monthsInCurrentPosition: 'Na obecnym stanowisku',
        personalGrade: 'Personal Grade',
        photo: 'Zdjęcie',
        positionName: 'Stanowisko',
        riskOfLeaving: 'Ryzyko odejścia',
      },
      groups: {
        basic: 'Podstawowe',
        details: 'Szczegóły',
        indicators: 'Wskaźniki',
      },
      hideAll: 'Ukryj wszystko',
      nodeTitle: 'Ustawienia widoku węzła',
      resetToDefault: 'Przywróć domyślne',
      showAll: 'Pokaż wszystko',
      title: 'Ustawienia widoku',
    },
    emptySimulation: {
      addFirstElement: 'Dodaj pierwszy element',
      description:
        'Ta symulacja jest pusta. Dodaj pierwszy element, aby rozpocząć budowanie struktury.',
      title: 'Pusta symulacja',
    },
    emptyState: {
      description: 'Przejdź do zakładki "Zarządzaj strukturami" aby wyświetlić i wybrać strukturę.',
      title: 'Wybierz strukturę',
    },
    legend: {
      addMode: {
        instructions: {
          greenBorderParent: 'Zielone obramowanie — przełożony',
          useSidePanelButtons: 'Użyj przycisków w panelu bocznym, aby wybrać węzły',
          yellowBorderChild: 'Żółte obramowanie — podlegli pracownicy',
        },
        selectChildren: 'Wybierz węzły podległych pracowników (żółte obramowanie)',
        selectParent: 'Wybierz węzeł przełożonego (zielone obramowanie)',
      },
      normalMode: {
        clickToExpand: 'Kliknij węzeł, aby rozwinąć lub zwinąć',
        dragBackground: 'Przeciągnij tło, aby przesunąć widok',
        dragNode: 'Przeciągnij węzeł, aby go przenieść',
      },
    },
    nodeLabels: {
      nodePrefix: 'Węzeł',
      subunitsCount: 'podjednostek',
      vacancy: 'Wolne stanowisko',
    },
    nodeListDrawer: {
      noResults: 'Nie znaleziono węzłów',
      searchHint: 'Wpisz min. 2 znaki aby wyszukać',
      searchPlaceholder: 'Szukaj po nazwie...',
      title: 'Lista węzłów',
      totalCount: 'węzłów',
    },
    search: {
      placeholder: 'Szukaj...',
    },
    searchNode: {
      foundCount: 'Znaleziono',
      nodeType: {
        employee: 'Pracownik',
        unit: 'Jednostka organizacyjna',
        vacancy: 'Wolne stanowisko',
      },
      noResults: 'Nie znaleziono jednostek pasujących do wyszukiwania',
      noResultsPersonal: 'Nie znaleziono osób pasujących do wyszukiwania',
      previewButton: 'Pokaż na wykresie',
      searchHint: 'Wprowadź nazwę jednostki aby rozpocząć wyszukiwanie (min. 2 znaki)',
      searchHintPersonal: 'Wprowadź nazwę pracownika aby rozpocząć wyszukiwanie (min. 2 znaki)',
      searchPlaceholder: 'Nazwa jednostki...',
      searchPlaceholderPersonal: 'Imię i nazwisko, stanowisko...',
      title: 'Wyszukaj jednostkę',
      titlePersonal: 'Wyszukaj osobę',
    },
    title: 'JM Polska S.A. - Struktura Organizacyjna',
    tooltips: {
      addNode: 'Dodaj element',
      collapse: 'Zwiń',
      deleteNode: 'Usuń element',
      expand: 'Rozwiń',
      goToProfile: 'Przejdź do profilu',
    },
    wrapper: {
      createNodeError: 'Nie udało się dodać węzła.',
      loadingStructure: 'Ładowanie struktury…',
      nodeCreated: 'Węzeł został dodany do struktury.',
      rootNodesError: 'Nie udało się wczytać punktów startowych.',
      simulationsError: 'Nie udało się wczytać symulacji',
      unknownTree: 'Nieznane',
    },
  },
  profilePictureModal: {
    cancel: 'Anuluj',
    delete: 'Usuń zdjęcie',
    deleteError: 'Nie udało się usunąć awatara. Spróbuj ponownie.',
    deleteSuccess: 'Awatar został pomyślnie usunięty!',
    deleting: 'Usuwanie...',
    dropImage: 'Upuść zdjęcie tutaj',
    save: 'Zapisz zdjęcie',
    selectDifferentImage: 'Wybierz inne zdjęcie',
    supportedFormats: 'Obsługiwane formaty: JPEG, PNG, GIF, WebP',
    title: 'Prześlij zdjęcie profilowe',
    uploadError: 'Nie udało się przesłać awatara. Spróbuj ponownie.',
    uploadImage: 'Kliknij lub przeciągnij aby przesłać zdjęcie',
    uploading: 'Przesyłanie...',
    uploadSuccess: 'Awatar został pomyślnie przesłany!',
    zoom: 'Powiększenie',
  },
  simulation: {
    accessModal: {
      addUsers: 'Dodaj użytkowników',
      buttons: {
        cancel: 'Anuluj',
        updateAccess: 'Zaktualizuj dostęp',
        updating: 'Aktualizowanie...',
      },
      description:
        'Zarządzaj tym, kto ma dostęp do edycji i zarządzania tą symulacją. Właściciel symulacji zawsze ma dostęp.',
      searchPlaceholder: 'Wyszukaj użytkowników po nazwie lub emailu...',
      selectedUsers: 'Użytkownicy z dostępem',
      simulationName: 'Symulacja',
      title: 'Zarządzaj dostępem do symulacji',
    },
    addNode: {
      sidePanel: {
        alerts: {
          employeeRequired: 'Musisz wybrać pracownika.',
          invalidPosition: 'Wybrane stanowisko jest nieprawidłowe.',
          positionRequired: 'Stanowisko jest wymagane dla wakatów.',
          selectParent: 'Musisz wybrać węzeł przełożonego przed dodaniem nowego węzła.',
          unitNameRequired: 'Nagłówek jest wymagany dla jednostek organizacyjnych.',
          vacancyNameRequired: 'Nagłówek jest wymagany dla wakatów.',
          validationError: 'Wystąpił błąd podczas walidacji formularza. Sprawdź wprowadzone dane.',
        },
        buttons: {
          add: {
            organizational: 'Dodaj',
            personal: 'Dodaj',
          },
          adding: 'Dodawanie...',
          cancel: 'Anuluj',
        },
        children: {
          label: {
            organizational: 'Podjednostki',
            personal: 'Podwładni',
          },
        },
        fields: {
          position: {
            createNew: 'Utwórz',
            creating: 'Dodawanie nowego stanowiska…',
            freeSoloHint: 'Możesz wpisać nowe stanowisko — zostanie dodane automatycznie',
            label: 'Stanowisko',
            noOptions: 'Brak opcji',
            required: 'Stanowisko jest wymagane',
          },
          searchEmployee: {
            hint: 'Wpisz imię, nazwisko lub numer SAP aby wyszukać',
            label: 'Wyszukaj pracownika',
            loading: 'Wyszukiwanie...',
            noOptions: 'Brak wyników',
            placeholder: 'Imię, nazwisko lub SAP...',
            required: 'Pracownik jest wymagany',
          },
          unitName: {
            label: 'Dodaj nagłówek',
            required: 'Nagłowek jest wymagany',
          },
        },
        nodeType: {
          employee: 'Pracownik',
          label: 'Dodaj:',
          organizational: 'Jednostka organizacyjna',
          vacancy: 'Wakat',
        },
        parent: {
          label: {
            organizational: 'Jednostka:',
            personal: 'Przełożony:',
          },
          rootNode: 'Element główny (root)',
          selectButton: {
            organizational: 'Kliknij aby wybrać jednostkę',
            personal: 'Kliknij aby wybrać przełożonego',
          },
          selectingButton: 'Kliknij węzeł na wykresie...',
        },
        selectedNodes: 'Wybrane węzły:',
        title: '',
      },
      tooltip: 'Dodaj nowy węzeł do struktury',
    },
    createModal: {
      buttons: {
        cancel: 'Anuluj',
        create: 'Utwórz symulację',
        creating: 'Tworzenie...',
      },
      fields: {
        description: {
          label: 'Opis',
          placeholder: 'Dodaj opis symulacji...',
        },
        empty: {
          label: 'Typ tworzenia symulacji',
          options: {
            copyStructure: 'Kopiuj aktualną strukturę',
            emptySimulation: 'Pusta symulacja',
          },
        },
        name: {
          label: 'Nazwa symulacji',
          placeholder: 'Wprowadź nazwę symulacji...',
        },
        type: {
          label: 'Typ symulacji *',
          options: {
            organizational: {
              description: 'Symulacja zmian w strukturze organizacyjnej',
              label: 'Organizacyjna',
            },
            personal: {
              description: 'Symulacja zmian personalnych',
              label: 'Personalna',
            },
          },
        },
      },
      title: 'Utwórz nową symulację',
    },
    editModal: {
      buttons: {
        cancel: 'Anuluj',
        update: 'Zaktualizuj symulację',
        updating: 'Aktualizowanie...',
      },
      fields: {
        description: {
          label: 'Opis (opcjonalnie)',
          placeholder: 'Zaktualizuj opis symulacji...',
        },
        name: {
          label: 'Nazwa symulacji',
          placeholder: 'Zaktualizuj nazwę symulacji...',
        },
      },
      title: 'Edytuj symulację',
    },
    rootNodeSelector: {
      defaultOption: 'JM Polska S.A. (domyślna)',
      label: 'Punkt startowy:',
      searchSupervisorPlaceholder: 'Wyszukaj przełożonego...',
      searchUnitPlaceholder: 'Wyszukaj unit...',
      subunitsText: 'podjednostek',
      viewDefault: 'Standardowy',
      viewSupervisor: 'Po przełożonym',
      viewUnit: 'Po unicie',
    },
    simulationSelector: {
      label: 'Widok:',
      main: {
        chip: 'GŁÓWNY',
        text: 'Struktura organizacyjna (bieżąca)',
      },
      simulation: {
        chip: 'SYM',
        createdText: 'Utworzona:',
      },
    },
    switchTreeDialog: {
      cancel: 'Anuluj',
      confirm: 'Przełącz na pełne drzewo',
      currentTree: 'Aktualne drzewo:',
      description: 'Wybrany węzeł znajduje się w innym drzewie organizacyjnym:',
      question: 'Co chcesz zrobić?',
      setAsRoot: 'Ustaw jako punkt startowy',
      subtitle: 'Wybrany węzeł należy do innego drzewa',
      targetTree: 'Docelowe drzewo:',
      title: 'Przełącz drzewo organizacyjne',
    },
    toolbar: {
      newSimulation: 'Nowa symulacja',
    },
  },
  simulationManagement: {
    buttons: {
      cancel: 'Anuluj',
      filters: 'Filtry',
      filtersActive: 'Filtry aktywne',
      newSimulation: 'Nowa symulacja',
      reset: 'Resetuj',
      retry: 'Spróbuj ponownie',
      showAll: 'Pokaż wszystkie',
    },
    confirmDeleteSimulation:
      'Czy na pewno chcesz permanentnie usunąć tę symulację? Ta operacja jest nieodwracalna i usunie wszystkie dane związane z symulacją.',
    currentStructures: 'Aktualne struktury:',
    errors: {
      deleteSimulation: 'Wystąpił błąd podczas usuwania symulacji',
      loadingData: 'Wystąpił błąd podczas ładowania danych',
      updateDetails: 'Wystąpił błąd podczas aktualizacji szczegółów',
      updateStatus: 'Wystąpił błąd podczas aktualizacji statusu',
    },
    filters: {
      active: 'Aktywne',
      allStatuses: 'Wszystkie statusy',
      allTypes: 'Wszystkie typy',
      archived: 'Zarchiwizowane',
      deleted: 'Usunięte',
      organizational: 'Organizacyjne',
      personal: 'Personalne',
    },
    initialView: {
      description: 'Wybierz opcję wyszukiwania',
      title: 'Zarządzanie symulacjami',
    },
    menu: {
      delete: 'Usuń',
      edit: 'Edytuj',
      manageAccess: 'Zarządzaj dostępem',
    },
    pagination: {
      showing: 'Wyświetlane: {{shown}} z {{total}} symulacji',
    },
    search: {
      placeholder: 'Szukaj symulacji...',
    },
    sidebar: {
      applyButton: 'Zastosuj filtry',
      resetButton: 'Wyczyść filtry',
      searchLabel: 'Wyszukiwanie tekstowe',
      statusLabel: 'Status symulacji',
      title: 'Filtry wyszukiwania',
      typeLabel: 'Typ symulacji',
    },
    status: {
      active: 'Aktywna',
      archived: 'Zarchiwizowana',
      deleted: 'Usunięta',
      unknown: 'Nieznany',
    },
    table: {
      empty: {
        noData: 'Brak symulacji do wyświetlenia',
        noResults: 'Żadna symulacja nie pasuje do wybranych filtrów',
      },
      headers: {
        access: 'Dostęp',
        actions: 'Akcje',
        author: 'Autor',
        created: 'Utworzona',
        description: 'Opis',
        lastModified: 'Zaaktualizowana',
        name: 'Nazwa',
        status: 'Status',
        type: 'Typ',
      },
    },
    types: {
      organizational: 'Organizacyjna',
      personal: 'Personalna',
    },
  },
  successorsForPosition: 'sukcesorów',
  tabs: {
    changelog: 'Historia',
    dashboard: 'Dashboard',
    filters: 'Szukaj',
    nestedStructure: 'Struktura zagnieżdżona',
    organizationChart: 'Struktura organizacyjna',
  },
};
